import React from "react";
import { Editor } from "slate";
import { Plugin } from "slate-react";
import { MARKS } from "../html";
import { AddHotkey } from "./hotkey";
import { AddIsToggledQuery } from "./isToggled";
import { AddToggleCommand } from "./toggleCommand";

const { type } = MARKS.UNDERLINE;

const isUnderline = (editor: Editor) => editor.value.marks.some(x => x.type === type);

const toggleUnderline = (editor: Editor) => editor.toggleMark(type);

/**
 * Slate plugin for underline formatting
 */
export const Underline: Plugin[] = [
  AddIsToggledQuery(type, isUnderline),
  AddToggleCommand(type, toggleUnderline),
  AddHotkey({ key: "u", action: toggleUnderline }),
  {
    renderMark: (props, controller, next) => {
      const { mark, attributes } = props;
      if (mark.type === type) {
        return <u {...attributes}>{props.children}</u>;
      }
      else {
        return next();
      }
    },
  },
];
